import { AppNavUser } from '~/components/new/app-ui/app-user-nav'
import { ExportsBell } from '~/components/new/exports/exports-bell'
import { cn } from '~/lib/utils'

export const AppHeader = ({
  children,
  className,
}: React.PropsWithChildren & { className?: string }) => (
  <header
    className={cn(
      'flex items-center bg-sidebar rounded-2xl p-4 border mb-2 justify-between border-sidebar-border gap-4',
      className,
    )}
  >
    {children}
    <div className="flex items-center gap-2" data-export-exclude>
      <ExportsBell />

      <AppNavUser className="w-fit" />
    </div>
  </header>
)
